import React from 'react';
import { Link } from 'react-router-dom';
import KnotDecoration from '../illustrations/KnotDecoration';
import LeafPattern from '../illustrations/LeafPattern';

export default function Hero({ onContactClick }) {
  return (
    <section className="relative min-h-screen flex items-center bg-cream overflow-hidden">
      <LeafPattern className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-auto max-h-[80vh] opacity-10 pointer-events-none hidden lg:block" />

      <div className="container-narrow relative z-10 pt-32 pb-20 lg:pt-40 lg:pb-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="lg:hidden mb-8 -mx-6 sm:-mx-8">
              <video
                autoPlay
                muted
                loop
                playsInline
                poster="/assets/hero-poster.jpg"
                className="w-full h-48 sm:h-56 object-cover"
              >
                <source src="/assets/hero-video.webm" type="video/webm" />
                <source src="/assets/hero-video.mp4" type="video/mp4" />
              </video>
            </div>
            <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-forest)] opacity-70 mb-6 uppercase">
              Clínica online de psicología
            </span>

            <h1 className="text-balance mb-6">
              Acompañamiento psicológico real, cercano y sin juicios
            </h1>

            <p className="text-lg md:text-xl text-[var(--color-inerva-text-light)] mb-10 max-w-xl leading-relaxed">
              <strong className="text-[var(--color-inerva-forest)]">Inerva</strong> nace de la amistad y del cuidado real:
              el que no exige, no empuja y no corrige. Un lugar donde sentirte escuchada de verdad, sin prisa y sin juicio.
              Te acompañamos con humanidad, perspectiva de género y un enfoque afirmativo, para que puedas volver a ti y
              caminar con más claridad.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <button onClick={onContactClick} className="btn-primary">
                Pide tu primera cita
              </button>
              <Link to="/servicios" className="btn-secondary">
                Conoce nuestros servicios
              </Link>
            </div>

          </div>

          <div className="hidden lg:block">
            <video
              autoPlay
              muted
              loop
              playsInline
              poster="/assets/hero-poster.jpg"
              className="w-full h-auto max-h-[70vh] object-cover rounded-2xl"
            >
              <source src="/assets/hero-video.webm" type="video/webm" />
              <source src="/assets/hero-video.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-8">
        <KnotDecoration size="lg" className="opacity-30" />
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <a href="#sobre-inerva" aria-label="Ir a la siguiente sección">
          <svg className="w-6 h-6 text-[var(--color-inerva-forest)] opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </a>
      </div>
    </section>
  );
}
